/* Potent — free-gift guard for the Speed Radar offer (v1.0).
   The bundle app adds the Stickhandling Ball Set as a free gift line linked to the radar line through
   its own line-item property (__kaching_bundles: the radar line has {id, main:true}, the gift line has
   {id, gift}). If the shopper removes the radar, the app leaves the gift in the cart at full price.
   This guard removes that orphaned, now-charged gift line and tells the shopper why. It only touches
   lines of the configured gift product that carry the app's gift property and whose radar line is gone;
   anything it cannot read is left alone, and a failed removal is flagged instead of hidden.
   Works on the cart page and the cart drawer (Impulse: cart:updated / ajaxProduct:added / cart:open). */
(() => {
  'use strict';
  const cfg = document.querySelector('[data-psr-gift-guard]');
  if (!cfg || !cfg.dataset.giftProduct) return;
  const giftProduct = String(cfg.dataset.giftProduct);
  const root = cfg.dataset.root || '/';
  const giftUrl = cfg.dataset.giftUrl || '';
  const KEY = 'psrGiftGuardNotice';
  const TEXT = {
    removed: 'Your free Stickhandling Ball Set was removed because the Speed Radar Gun is no longer in your cart.',
    failed: 'Your Stickhandling Ball Set is no longer free because the Speed Radar Gun was removed. Remove it below if you don’t want to buy it.'
  };
  let busy = false;
  let noticeUntil = 0;
  const parse = v => { try { return JSON.parse(v); } catch (_) { return null; } };
  const orphans = cart => {
    const rows = (cart.items || []).map(item => ({item, p: parse(item.properties && item.properties.__kaching_bundles)}));
    const mains = new Set(rows.filter(r => r.p && r.p.main && r.p.id != null).map(r => String(r.p.id)));
    return rows.filter(r => r.p && r.p.gift && r.p.id != null && String(r.item.product_id) === giftProduct &&
      !mains.has(String(r.p.id)) && r.item.final_line_price > 0).map(r => r.item);
  };
  const render = kind => {
    document.querySelectorAll('[data-psr-gift-notice]').forEach(n => n.remove());
    // Where to show it: outside the cart lines, so it stays visible even when the cart becomes empty.
    const spots = [];
    const page = document.getElementById('CartPageForm');
    const pageHeader = document.querySelector('[data-cart-page-empty]')?.closest('header');
    if (page) spots.push([page, 'beforebegin']); else if (pageHeader) spots.push([pageHeader, 'afterend']);
    const drawerHead = document.querySelector('#CartDrawer .drawer__fixed-header');
    if (drawerHead) spots.push([drawerHead, 'afterend', true]);
    spots.forEach(([el, where, inDrawer]) => {
      const box = document.createElement('p');
      box.setAttribute('data-psr-gift-notice', kind);
      box.setAttribute('role', 'status');
      box.style.cssText = 'margin:12px 0 16px;padding:10px 12px;border-left:3px solid #ec7909;background:#fff6ee;color:#1b1b1b;font-size:14px;line-height:1.45;text-align:left';
      box.textContent = TEXT[kind] + ' ';
      if (kind === 'removed' && giftUrl) {
        const a = document.createElement('a');
        a.href = giftUrl; a.textContent = 'Shop the ball set'; a.style.textDecoration = 'underline';
        box.appendChild(a);
      }
      if (inDrawer) {   // line up with the drawer title
        const title = document.querySelector('#CartDrawer .drawer__title');
        const side = title ? Math.max(0, Math.round(title.getBoundingClientRect().left - document.getElementById('CartDrawer').getBoundingClientRect().left)) : 20;
        box.style.marginLeft = box.style.marginRight = side + 'px';
      }
      el.insertAdjacentElement(where, box);
    });
  };
  const check = async () => {
    if (busy) return;
    busy = true;
    try {
      const cart = await fetch(`${root}cart.js`, {credentials: 'same-origin', cache: 'no-store'}).then(r => r.json());
      let list = orphans(cart);
      if (!list.length) return;
      // The app adds the gift a moment before the radar. Confirm the gift is still orphaned 2.5 s later.
      await new Promise(r => setTimeout(r, 2500));
      const again = await fetch(`${root}cart.js`, {credentials: 'same-origin', cache: 'no-store'}).then(r => r.json());
      const keys = new Set(list.map(i => i.key));
      list = orphans(again).filter(i => keys.has(i.key));
      if (!list.length) return;
      const updates = {};
      list.forEach(item => { updates[item.key] = 0; });
      const res = await fetch(`${root}cart/update.js`, {
        method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({updates})
      });
      if (!res.ok) throw new Error('update failed');
      try { sessionStorage.setItem(KEY, 'removed'); } catch (_) {}
      if (document.getElementById('CartPageForm')) { location.reload(); return; }
      noticeUntil = Date.now() + 6000;
      document.dispatchEvent(new CustomEvent('cart:build'));
      setTimeout(() => render('removed'), 600);
    } catch (_) {
      render('failed');
    } finally { busy = false; }
  };
  const pending = () => { try { const k = sessionStorage.getItem(KEY); if (k) { sessionStorage.removeItem(KEY); render(k); } } catch (_) {} };
  ['cart:updated', 'ajaxProduct:added', 'cart:open'].forEach(name => document.addEventListener(name, () => {
    if (Date.now() < noticeUntil) setTimeout(() => render('removed'), 50);   // the drawer was rebuilt: show the notice again
    setTimeout(check, 150);
  }));
  window.addEventListener('pageshow', () => check());
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { pending(); check(); });
  else { pending(); check(); }
})();
